import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';
import { FbService } from 'src/app/services/fb.service';

@Component({
  selector: 'produto-page',
  templateUrl: './produto-page.component.html',
  styleUrls: ['./produto-page.component.scss']
})
export class ProdutoPageComponent implements OnInit {

  public loader           = false;
  public apelido          = null;
  public apelidoCategoria = null;
  public response:any = {
    data: null,
    status: null
  }
  public dataB  = null;
  public inCart = false;

  public destroy    = false;
  public mySubscription:Subscription;
  public destroyed  = new Subject<any>();
  public produto:any   = null;
  public categoria:any = null;
  public fotos:any     = null;
  public textos:any    = null;
  public produtos:any  = [];
  public configuracaoLoja:any = null;
  public estoque:any = {
    total_in: 0,
    total_out: 0,
    quantidade_atual: 0,
    total_in_cart: 0
  }
  
  constructor(
    private api: ApiService,
    private app: AppService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FbService 
  ){

    this.apelido          = typeof(this.route.params["_value"].apelido_produto) != "undefined" ? this.route.params["_value"].apelido_produto : null;
    this.apelidoCategoria = typeof(this.route.params["_value"].apelido_categoria) != "undefined" ? this.route.params["_value"].apelido_categoria : null;

  }
  /**
   * 
   * Get data
   * 
   */
  getData(){

    try{

      this.loader = true;
      this.response.status = null;

      this.api.produto().produto(this.apelido).subscribe(response => {

        this.loader = false;

        if(response.status == 1){

          this.produto          = response.data.produto;
          this.categoria        = response.data.categoria;
          this.fotos            = response.data.fotos;
          this.textos           = response.data.textos;
          this.produtos         = response.data.relacionados;
          this.configuracaoLoja = response.data.configuracao;
          this.inCart           = response.data.in_cart;

          this.fb.viewContent({
            categoria: this.categoria.titulo,
            nome: this.produto.nome,
            valor: this.produto.valor
          });

          this.app.setMetaDados(this.produto.meta_title,this.produto.meta_description);

          this.setEstoque(response.data.estoque);

          this.response.status = 1;
          this.setBreadcrumbs();

        }else{

          let error   = this.app.formatError(response);

          this.response = {
            data: error.message,
            status: 500
          } 

        }
        setTimeout(() => {
          this.app.toTop();
        },200);
        

      },(response) => {

        this.loader = false;
        let error   = this.app.formatError(response);

        this.response = {
          data: error.message,
          status: 500
        }

        setTimeout(() => {
          this.app.toTop();
        },200); 

      });

    }catch(e){

      this.loader = false;
      this.response = {
        data: e.message,
        status: 500
      }

    }

  }
  /**
   * 
   * Set estoque
   * 
   */
  setEstoque(estoque){

    if(estoque != null && estoque != "null"){

      this.estoque = estoque;

    }

  }
  /**
   * 
   * Set breadcrumbs
   * 
   */ 
  setBreadcrumbs(){

    this.dataB = [{
      text: "Produtos",
      link: "/produtos"
    },{
      text: this.categoria.titulo,
      link: "/produtos/"+this.categoria.apelido
    },{
      text: this.produto.nome,
      link: "/produtos/"+this.categoria.apelido+"/"+this.produto.apelido
    }]

  }
  /**
   * 
   * Inicializa as Funções
   * 
   */
   ngOnInit(){

    this.app.toTop();
    this.getData();

    this.mySubscription = this.router.events.pipe(
      filter((event:RouterEvent) => event instanceof NavigationEnd),
      takeUntil(this.destroyed)
    ).subscribe(() => {
      
      if(!this.destroy){
        this.apelido = this.route.params["_value"].apelido_produto;
        this.getData();
      }  

    });


  }
  /**
   * 
   * Destroy
   * 
   * 
   */
   ngOnDestroy() {
    
    if(this.mySubscription){
      
      this.destroy         = true;
      this.mySubscription.unsubscribe(); 
    
    }

  }

}
